import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { TfiCheck, TfiAlert } from "react-icons/tfi";
/* import _ from "lodash"; */
import { useMatchContext } from "../context/match_context";

const GameIdManagement = () => {
  const { match, gameIds, updateMatchGameIds, loading, error } =
    useMatchContext();
  const [games, setGames] = useState([]);
  const [errorLock, setErrorLock] = useState(false);
  var gamesTemplate_PA3 = [
    {
      sequence: 1,
      gameAoe2Id: "",
      description: `HM ${match.playerAusername}`, // this field will be omited in BE. It's used only for frontal purposes
      error: "", // this field will be omited in BE. It's used only for frontal purposes
    },
    {
      sequence: 2,
      gameAoe2Id: "",
      description: `HM ${match.playerBusername}`, // this field will be omited in BE. It's used only for frontal purposes
      error: "", // this field will be omited in BE. It's used only for frontal purposes
    },
    {
      sequence: 3,
      gameAoe2Id: "",
      description: `3º mapa`, // this field will be omited in BE. It's used only for frontal purposes
      error: "", // this field will be omited in BE. It's used only for frontal purposes
    },
  ];

  var gamesTemplate_BO5 = [
    {
      sequence: 1,
      gameAoe2Id: "",
      description: `HM ${match.playerAusername}`, // this field will be omited in BE. It's used only for frontal purposes
      error: "", // this field will be omited in BE. It's used only for frontal purposes
    },
    {
      sequence: 2,
      gameAoe2Id: "",
      description: `HM ${match.playerBusername}`, // this field will be omited in BE. It's used only for frontal purposes
      error: "", // this field will be omited in BE. It's used only for frontal purposes
    },
    {
      sequence: 3,
      gameAoe2Id: "",
      description: `Mapa neutro`, // this field will be omited in BE. It's used only for frontal purposes
      error: "", // this field will be omited in BE. It's used only for frontal purposes
    },
    {
      sequence: 4,
      gameAoe2Id: "",
      description: `HM del que vaya perdiendo`, // this field will be omited in BE. It's used only for frontal purposes
      error: "", // this field will be omited in BE. It's used only for frontal purposes
    },
    {
      sequence: 5,
      gameAoe2Id: "",
      description: `Último mapa que queda`, // this field will be omited in BE. It's used only for frontal purposes
      error: "", // this field will be omited in BE. It's used only for frontal purposes
    },
  ];

  const compareGameIds = (games1, games2) => {
    const fields = ["gameAoe2Id", "sequence"];

    if (games1.length !== games2.length) {
      return false;
    }

    var index = 0;
    for (var i = 0; index < games1.length; index++) {
      const game1 = games1[i];
      const game2 = games2[i];
      for (const field of fields) {
        if (!(game1[field] === game2[field])) {
          return false;
        }
      }
    }
    return true;
  };

  const initializeGames = (games, template) => {
    var toRet = [...template];
    for (var index = 0; index < toRet.length; index++) {
      for (const temp of games) {
        if (toRet[index].sequence === temp.sequence) {
          toRet[index].gameAoe2Id = temp.gameAoe2Id;
          break;
        }
      }
    }
    return toRet;
  };

  useEffect(() => {
    if (!loading && !error) {
      var temp = {};
      if (match.gamesFormat === "PA3") {
        temp = initializeGames(gameIds, gamesTemplate_PA3);
      } else {
        temp = initializeGames(gameIds, gamesTemplate_BO5);
      }
      setGames([...temp]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loading && !error) {
      var temp = {};
      if (match.gamesFormat === "PA3") {
        temp = initializeGames(gameIds, gamesTemplate_PA3);
      } else {
        temp = initializeGames(gameIds, gamesTemplate_BO5);
      }
      setGames([...temp]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameIds, loading, error, match]);

  useEffect(() => {
    if (games.length > 0 && !compareGameIds(games, gameIds) && !errorLock) {
      updateMatchGameIds([...games]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [games]);

  const onChangeValue = (value, game) => {
    if (value && value.length > 0) {
      const nextGames = games.map((g, i) => {
        if (g.sequence === game.sequence) {
          var game_temp = g;
          game_temp.gameAoe2Id = value;

          // Allowed formats: aoe2de://x/xxxxxxxxxxx
          const regex = /aoe2de:\/\/\d\/\d(\d)+/gm;

          var m = regex.exec(value);
          if (m !== null) {
            game_temp.error = "";
          } else {
            game_temp.error = "El formato del id de partida es incorrecto";
          }
          return game_temp;
        } else {
          // The rest haven't changed
          return g;
        }
      });

      var errorList = nextGames.filter((g) =>
        g.error.length > 0 ? true : false
      );
      if (errorList.length === 0) {
        setErrorLock(false);
      } else {
        setErrorLock(true);
      }

      setGames(nextGames);
    }
  };

  if (loading) {
    return <div>Cargando...</div>;
  }
  if (error) {
    return (
      <div>Se ha producido un error cargando la información de la partida</div>
    );
  }

  return (
    <Wrapper>
      <p className="infoBox" style={{ display: "none" }}>
        Por favor en cuanto creéis la sala poned el id de partida aquí.
      </p>
      <div className="explanation" style={{ display: "none" }}>
        ¿Por qué necesitamos esta info?
        <ul>
          <li>
            Intentar obtener de forma automática toda la información de la
            partida a través de aoe2.net
          </li>
          <li>Descargar las recs cuando hayan acabado las partidas</li>
          <li>
            Info para los <u>casters</u> que podrán espectar la partida mientras
            se juega.
          </li>
        </ul>
      </div>
      <h5>Orden de juego de las partidas:</h5>

      {games.map((game) => {
        return (
          <div className="game" key={`map-aoeId-${game.sequence}`}>
            <div className="map">{game.description}</div>
            {/* // TODO: MAPA CARGADO DINÁMICAMENTE DEL DRAFT
            <div className="map">
            <img
              src="https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_arabia.png"
              alt="arabia"
            />
          </div> */}
            <input
              className="input-text-field-big"
              type="text"
              placeholder="aoe2de://x/xxxxxxxxxxx"
              value={game.gameAoe2Id ? game.gameAoe2Id : ""}
              onChange={(event) => onChangeValue(event.target.value, game)}
              name={`gameAoe2Id-${game.sequence}`}
            />
            {game.error ? (
              <div className="game-icon-status">
                <TfiAlert />
              </div>
            ) : (
              ""
            )}
            {!game.error && game.gameAoe2Id ? (
              <div className="game-icon-status">
                <TfiCheck />
              </div>
            ) : (
              ""
            )}
            {/* // TODO: ESTADO DEL STATUS OBTENIDO VÍA AOE2NET
            <div className="game-icon-status loading"></div>
            <div className="game-icon-status">
              <TfiAlert />
            </div>
            <div className="game-icon-status">
              <TfiCheck />
            </div> */}
          </div>
        );
      })}

      <p className="infoBox">
        Por favor en cuanto creéis la sala poned el id de partida aquí.
      </p>
      <div className="explanation">
        ¿Por qué necesitamos esta info?
        <ul>
          <li>Descargar las recs cuando hayan acabado las partidas</li>
          <li>
            Info para los <u>casters</u> que podrán espectar la partida mientras
            se juega.
          </li>
        </ul>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .explanation {
    font-style: italic;

    ul {
      list-style: square inside;
    }
  }

  .game {
    display: flex;
    align-items: center;

    .input-text-field-big {
      width: 60% !important;
      margin-right: 1rem;
    }
    .map {
      width: 8rem;
    }
    .map img {
      width: 6rem;
      margin-right: 1rem;
    }
  }
  .game-icon-status {
    //display: none; // TODO: obtener datos de la partida de forma automática
    width: 2rem;
    height: 2rem;
    margin: 0;
  }
`;

export default GameIdManagement;
